function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import isEqual from 'lodash/isEqual';
import Table from "../Table/Table";
import TableUtil from "../Table/TableUtil";
import SortableHeader from "./SortableHeader";
import { NO_SORT, ASCENDING } from "./SortingDirection";
var SortableTable = /*#__PURE__*/function (_React$Component) {
  function SortableTable(props, context) {
    var _this;
    _classCallCheck(this, SortableTable);
    _this = _callSuper(this, SortableTable, [props, context]);
    _defineProperty(_this, "_table", void 0);
    _defineProperty(_this, "toggleExpandRow", function (row) {
      _this.setState({
        expandedRows: TableUtil.updateExpandedRows(_this.state.expandedRows || {}, row)
      });
    });
    _this.state = _this.generateInitialState(props);
    return _this;
  }
  _inherits(SortableTable, _React$Component);
  return _createClass(SortableTable, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      if (this.props.columns.length !== nextProps.columns.length) {
        // If the columns are completely changed, then generate initial state completely
        this.setState(this.generateInitialState(nextProps));
      } else {
        // If not, then only update the sortedRowIndices
        this.setState(function (oldState) {
          var _this2$state = _this2.state,
            sortingColumn = _this2$state.sortingColumn,
            sortingDirection = _this2$state.sortingDirection;
          return {
            sortedRowIndices: _this2.getSortedRowIndices(nextProps.rows, sortingColumn, sortingDirection)
          };
        });
      }
      if (!isEqual(nextProps.expandedRows, this.props.expandedRows)) {
        this.setState({
          expandedRows: nextProps.expandedRows
        });
      }
    }
  }, {
    key: "getTable",
    value: function getTable() {
      return this._table;
    }
  }, {
    key: "generateInitialState",
    value: function generateInitialState(props) {
      return {
        sortingColumn: 0,
        sortingDirection: NO_SORT,
        sortedRowIndices: this.getSortedRowIndices(props.rows, 0, NO_SORT),
        expandedRows: props.expandedRows || {}
      };
    }
  }, {
    key: "rowInfo",
    value: function rowInfo(rowIndex, callback) {
      var rows = this.props.rows;
      var sortedRowIndices = this.state.sortedRowIndices;
      var index = sortedRowIndices[rowIndex];
      return callback(rows[index], index);
    }
  }, {
    key: "getRowAttributeCallback",
    value: function getRowAttributeCallback(rowAttribute) {
      var _this3 = this;
      return function (_, rowIndex) {
        return _this3.rowInfo(rowIndex, rowAttribute);
      };
    }
  }, {
    key: "getRowEventCallback",
    value: function getRowEventCallback(callback) {
      var _this4 = this;
      return function (event, _, rowIndex) {
        return _this4.rowInfo(rowIndex, function (row, index) {
          return callback(event, row, index);
        });
      };
    }
  }, {
    key: "getSortedRowIndices",
    value: function getSortedRowIndices(rows, columnIndex, direction) {
      var columns = this.props.columns;
      var _columns$columnIndex = columns[columnIndex],
        accessor = _columns$columnIndex.accessor,
        comparator = _columns$columnIndex.comparator;
      var indices = rows.map(function (_, index) {
        return index;
      });
      if (direction === NO_SORT) {
        return indices;
      } else {
        // Generate basic compare function
        var compare = function compare(i1, i2) {
          var item1 = rows[i1][accessor];
          var item2 = rows[i2][accessor];
          return comparator ? comparator(item1, item2) : item1 > item2 ? 1 : -1;
        };

        // Sort a copy of sortedRowIndices. Depending on the sorting direction, inverse the compareFunc
        return indices.sort(direction === ASCENDING ? compare : function (i1, i2) {
          return compare(i2, i1);
        });
      }
    }
  }, {
    key: "handleSortStateChange",
    value: function handleSortStateChange(columnIndex, direction) {
      var _this5 = this;
      var rows = this.props.rows;
      this.setState(function (oldState) {
        var sortedIndices = _this5.getSortedRowIndices(rows, columnIndex, direction);
        return {
          sortingColumn: columnIndex,
          sortingDirection: direction,
          sortedRowIndices: sortedIndices
        };
      }, function () {
        // Since we changed the sorting status, the row heights are now changed, so we need to force the virtualized
        // table to update the row heights.
        _this5._table && _this5._table.forceUpdateRowHeights();
      });
    }
  }, {
    key: "generateColumns",
    value: function generateColumns() {
      var _this6 = this;
      var columns = this.props.columns;
      var _this$state = this.state,
        sortingColumn = _this$state.sortingColumn,
        sortingDirection = _this$state.sortingDirection,
        sortedRowIndices = _this$state.sortedRowIndices,
        expandedRows = _this$state.expandedRows;
      return columns.map(function (column, columnIndex) {
        var accessor = column.accessor,
          width = column.width,
          header = column.header,
          cellRenderer = column.cellRenderer,
          sortable = column.sortable;
        var isSortingCurrentColumn = sortingColumn === columnIndex;
        return {
          accessor: accessor,
          width: width,
          header: sortable ? function (visible) {
            return _this6.renderSortableHeader(visible, header, columnIndex);
          } : header,
          cellRenderer: cellRenderer && function (cell, row, rowIndex) {
            return cellRenderer(cell, row, sortedRowIndices[rowIndex], _this6.toggleExpandRow, expandedRows[row.key]);
          },
          htmlProps: sortable ? {
            'aria-sort': isSortingCurrentColumn ? sortingDirection : NO_SORT
          } : {}
        };
      });
    }
  }, {
    key: "generateRows",
    value: function generateRows() {
      var rows = this.props.rows;
      var _this$state2 = this.state,
        sortedRowIndices = _this$state2.sortedRowIndices,
        sortingDirection = _this$state2.sortingDirection;
      var generatedRows = sortingDirection === NO_SORT ? rows : sortedRowIndices.map(function (index) {
        return rows[index];
      });
      return generatedRows;
    }
  }, {
    key: "renderSortableHeader",
    value: function renderSortableHeader(isVisibleHeader, header, columnIndex) {
      var _this7 = this;
      var _this$state3 = this.state,
        sortingColumn = _this$state3.sortingColumn,
        sortingDirection = _this$state3.sortingDirection;
      return /*#__PURE__*/React.createElement(SortableHeader, {
        isVisibleHeader: isVisibleHeader,
        sortingColumn: sortingColumn,
        sortingDirection: sortingDirection,
        currentColumn: columnIndex,
        header: header,
        onChange: function onChange(columnIndex, direction) {
          return _this7.handleSortStateChange(columnIndex, direction);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;
      var _this$props = this.props,
        width = _this$props.width,
        height = _this$props.height,
        rowStyle = _this$props.rowStyle,
        rowRootClassName = _this$props.rowRootClassName,
        onClick = _this$props.onClick,
        onDoubleClick = _this$props.onDoubleClick,
        onMouseDown = _this$props.onMouseDown,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseLeave = _this$props.onMouseLeave,
        onMouseMove = _this$props.onMouseMove,
        onMouseOut = _this$props.onMouseOut,
        onMouseOver = _this$props.onMouseOver,
        onMouseUp = _this$props.onMouseUp,
        enableExpandableRows = _this$props.enableExpandableRows;
      return /*#__PURE__*/React.createElement(Table, _extends({
        ref: function ref(_ref) {
          return _this8._table = _ref;
        },
        columns: this.generateColumns(),
        rows: this.generateRows(),
        width: width,
        height: height,
        expandedRows: this.state.expandedRows,
        enableExpandableRows: enableExpandableRows
      }, rowStyle && {
        rowStyle: this.getRowAttributeCallback(rowStyle)
      }, rowRootClassName && {
        rowRootClassName: this.getRowAttributeCallback(rowRootClassName)
      }, onClick && {
        onClick: this.getRowEventCallback(onClick)
      }, onDoubleClick && {
        onDoubleClick: this.getRowEventCallback(onDoubleClick)
      }, onMouseDown && {
        onMouseDown: this.getRowEventCallback(onMouseDown)
      }, onMouseEnter && {
        onMouseEnter: this.getRowEventCallback(onMouseEnter)
      }, onMouseLeave && {
        onMouseLeave: this.getRowEventCallback(onMouseLeave)
      }, onMouseMove && {
        onMouseMove: this.getRowEventCallback(onMouseMove)
      }, onMouseOut && {
        onMouseOut: this.getRowEventCallback(onMouseOut)
      }, onMouseOver && {
        onMouseOver: this.getRowEventCallback(onMouseOver)
      }, onMouseUp && {
        onMouseUp: this.getRowEventCallback(onMouseUp)
      }));
    }
  }]);
}(React.Component);
export default SortableTable;